import {
  Marquee,
  NumbersTitle,
  SpinningContainer,
  Track,
} from "./styles";
import Medsi from "../../content/assets/Medsi";
import Sber from "../../content/assets/Sber";
import Gazprom from "../../content/assets/Gazprom";
import Rennisanse from "../../content/assets/Rennisanse";
import Echelon from "../../content/assets/Echelon";
import GoldenApple from "../../content/assets/GoldenApple";
import Steklo from "../../content/assets/Steklo";
import { textData as data } from "../../content/data/HomeData";
import useIsMobile from "../../common/hooks/useIsMobile";
import React from "react";

export const Spinning = () => {
  const isMoblie = useIsMobile();

  return (
    <>
      {isMoblie ? <NumbersTitle>{data.clients}</NumbersTitle> : null}
      <SpinningContainer gap="2vw" align="center">
        {!isMoblie ? <NumbersTitle>{data.clients}</NumbersTitle> : null}
        <Marquee align="center">
          <Track>
            {Array(2)
              .fill(<></>)
              .map((_, ind) => (
                <React.Fragment key={ind}>
                  <span style={{ marginLeft: "3vw" }}>
                    <Medsi />
                  </span>
                  <span style={{ marginLeft: "3vw" }}>
                    <Sber />
                  </span>
                  <span style={{ marginLeft: "3vw" }}>
                    <Gazprom />
                  </span>
                  <span style={{ marginLeft: "3vw" }}>
                    <Rennisanse />
                  </span>
                  <span style={{ marginLeft: "3vw" }}>
                    <Echelon />
                  </span>
                  <span style={{ marginLeft: "3vw" }}>
                    <GoldenApple />
                  </span>
                  <span style={{ marginLeft: "3vw" }}>
                    <Steklo />
                  </span>
                </React.Fragment>
              ))}
          </Track>
        </Marquee>
      </SpinningContainer>
    </>
  );
};
